import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Timetable from "Administrator/routes/Timetable";
import { AssessmentDetails } from "Assessments";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

export default store => ({
  path: "teacher-timetable",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "timetable" */ "./components"),
        import(
          /* webpackChunkName: "teacher-profile" */ "TimetableConfiguration/modules/TimetableConfigurationModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const timeTableReducer = importedModule1;
        injectReducer(store, {
          key: timeTableReducer.NAME,
          reducer: timeTableReducer.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Timetable(store),
    ClassRoomDetails(store),
    AssessmentDetails(store),
  ],
});
